import FileSaver from 'file-saver';
import React from 'react';
import { Button, Form } from 'react-bootstrap';


export const ExcelExampleModel = () => {
  const DownloadCSV = () => {
    const headers = ['mobile_number', "tags", 'name'];

    const columnData = [['+601169369480', 'tag1,tag2,tag3', 'Jason']];

    const escapeField = (field) => {
      if (field.includes(',')) {
        return `"${field}"`;
      }
      return field;
    };

    const csv = `${headers.join(',')}\r\n${columnData.map(row => row.map(escapeField).join(',')).join('\r\n')}`;
    const blob = new Blob([csv], {
      type: 'text/csv',
    });
    FileSaver.saveAs(blob, 'sample_contacts_file.csv');
  };

  return (
    <Form.Group>
      <Button variant="ghost" className="w-100" onClick={DownloadCSV}>
        Download CSV Sample
      </Button>
    </Form.Group>
  );
};


export const TxtExampleModel = () => {

  const DownloadFile = () => {
    const data = [
      '601169369480',
      '601169369485',
      '601169369487'
    ];
    const content = data.join(',\n');
    const blob = new Blob([content], {
      type: 'text/plain;charset=utf-8',
    });
    FileSaver.saveAs(blob, 'Sample File.txt');
  };

  return (
    <Form.Group>
      <Button variant="ghost" className="w-100" onClick={DownloadFile}>
        Download TXT Sample
      </Button>
    </Form.Group>
  );
};
